var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFrenchFries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.955,
    x2: 202.277,
    xlinkHref: "#lg1",
    y1: 163.512,
    y2: 210.792
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.695,
    x2: 63.153,
    xlinkHref: "#lg2",
    y1: 184.102,
    y2: 202.864
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.771,
    x2: 242.736,
    xlinkHref: "#lg1",
    y1: 102.819,
    y2: 154.603
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.574,
    x2: 338.352,
    xlinkHref: "#lg1",
    y1: 159.136,
    y2: 167.017
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.969,
    x2: 389.743,
    xlinkHref: "#lg1",
    y1: 175.801,
    y2: 178.053
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(1.001 .008 .008 1.079 8.204 81.789)",
    gradientUnits: "userSpaceOnUse",
    x1: 196.898,
    x2: 131.606,
    xlinkHref: "#lg1",
    y1: 88.82,
    y2: 118.089
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.986 .17 -.17 .986 -152.812 10.508)",
    gradientUnits: "userSpaceOnUse",
    x1: 555.618,
    x2: 665.939,
    xlinkHref: "#lg1",
    y1: 44.205,
    y2: 91.486
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.555,
    x2: 489.366,
    xlinkHref: "#lg2",
    y1: 121.505,
    y2: 422.45
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.995 -.1 .1 .995 74.022 -63.673)",
    gradientUnits: "userSpaceOnUse",
    x1: 149.732,
    x2: 260.938,
    xlinkHref: "#lg1",
    y1: 249.375,
    y2: 297.034
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.964 -.267 .267 .964 218.47 -114.633)",
    gradientUnits: "userSpaceOnUse",
    x1: -76.216,
    x2: 18.949,
    xlinkHref: "#lg2",
    y1: 175.114,
    y2: 480.404
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.123,
    x2: 288.889,
    xlinkHref: "#lg2",
    y1: 331.475,
    y2: 83.184
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.11,
    x2: 43.53,
    xlinkHref: "#lg2",
    y1: 272.316,
    y2: 183.889
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.483,
    x2: 407.13,
    xlinkHref: "#lg1",
    y1: 230.023,
    y2: 284.3
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.514,
    x2: 361.201,
    xlinkHref: "#lg2",
    y1: 247.365,
    y2: 269.88
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.98 -.198 .198 .98 163.071 -94.623)",
    gradientUnits: "userSpaceOnUse",
    x1: -187.978,
    x2: -82.159,
    xlinkHref: "#lg1",
    y1: 264.957,
    y2: 324.621
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.39,
    x2: 189.808,
    xlinkHref: "#lg1",
    y1: 228.732,
    y2: 260.252
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.13,
    x2: 250.13,
    y1: 226.689,
    y2: 353.916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2662,
    stopColor: "#ee2818",
    stopOpacity: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7123,
    stopColor: "#d42724",
    stopOpacity: 0.712
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.536,
    x2: 441.74,
    y1: 315.7,
    y2: 449.662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#fe5b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#fc4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.836,
    x2: 269.059,
    xlinkHref: "#lg2",
    y1: 531.951,
    y2: 345.08
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.944,
    x2: 286.534,
    xlinkHref: "#lg1",
    y1: 351.153,
    y2: 455.84
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.765,
    x2: 252.765,
    xlinkHref: "#lg2",
    y1: 464.217,
    y2: 529.983
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104.925 339.929 33.247.318c7.476.071 13.595-5.931 13.666-13.407l2.231-299.646c.096-10.081-10.466-16.727-19.512-12.276l-28.706 14.122c-7.47 3.675-12.233 11.245-12.312 19.569l-2.021 277.655c-.071 7.475 5.931 13.594 13.407 13.665z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.609 223.84-.766 103.004c-.079 7.475-6.191 13.475-13.666 13.407l-33.254-.326c-7.475-.068-13.475-6.192-13.407-13.667l2.026-277.65c.056-6.541 3.017-12.608 7.891-16.672l36.485 181.119c1.385 6.913 7.824 11.517 14.691 10.785z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.521 339.929-33.247.318c-7.476.071-13.595-5.931-13.666-13.407l-2.231-299.646c-.096-10.081 10.466-16.727 19.512-12.276l28.706 14.122c7.47 3.675 12.233 11.245 12.312 19.569l2.021 277.655c.072 7.475-5.931 13.594-13.407 13.665z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.062 326.42-33.247.318c-7.476.071-13.595-5.931-13.666-13.407l-2.231-299.646c-.096-10.082 10.466-16.727 19.512-12.277l28.706 14.122c7.47 3.675 12.233 11.245 12.312 19.569l2.021 277.655c.072 7.476-5.931 13.595-13.407 13.666z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.476 302.596-33.083 3.318c-7.439.746-14.075-4.679-14.821-12.119l-23.308-232.365c-1.006-10.031 8.913-17.603 18.324-13.988l29.864 11.472c7.771 2.985 13.198 10.094 14.029 18.377l21.113 210.484c.747 7.439-4.679 14.075-12.118 14.821z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.265 333.479-33.083 3.318c-7.439.746-14.123-5.162-14.929-13.197l-25.175-250.974c-1.087-10.835 8.78-18.928 18.227-14.951l29.979 12.619c7.801 3.284 13.289 10.999 14.186 19.946l22.804 227.339c.807 8.035-4.57 15.153-12.009 15.9z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m385.371 334.518 32.71 5.963c7.355 1.341 14.405-3.535 15.746-10.89l53.122-294.908c1.808-9.918-7.471-18.262-17.142-15.414l-30.689 9.038c-7.986 2.352-13.966 9.002-15.459 17.192l-49.177 273.273c-1.342 7.356 3.533 14.405 10.889 15.746z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.117 28.307c-7.986 2.352-13.966 9.002-15.459 17.192l-49.177 273.273c-1.341 7.355 3.535 14.405 10.89 15.746l6.084 1.109c1.805-2.137 3.128-4.839 3.687-7.905l54.577-302.537z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m278.555 346.431 33.114-3.041c7.446-.684 12.936-7.368 12.263-14.93l-27.614-303.014c-.908-10.197-12.079-15.844-20.638-10.432l-27.158 17.173c-7.067 4.469-11.052 12.599-10.303 21.019l25.634 280.772c.674 7.561 7.256 13.136 14.702 12.453z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.522 32.186c-7.067 4.469-11.052 12.599-10.303 21.019l25.634 280.772c.673 7.562 7.255 13.137 14.701 12.454l6.159-.566c1.169-2.581 1.721-5.585 1.44-8.737l-28.249-310.874z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m431.546 211.847c-.735-1.016-1.62-1.96-2.683-2.787l-107.355-80.847c-22.136-17.288-52.737-6.022-59.475 21.245l-11.712 36.302 13.532 148.217c.673 7.562 7.255 13.138 14.701 12.454l33.114-3.041c7.446-.684 12.936-7.368 12.263-14.93l-.16-1.76 29.29-.28c7.476-.071 13.479-6.19 13.407-13.666l-.058-8.012c2.114.971 4.5 1.421 6.982 1.172l3.464-.347-2.376 13.205c-1.341 7.355 3.535 14.405 10.89 15.746l32.71 5.963c7.355 1.341 14.405-3.535 15.746-10.89l17.624-97.84z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m211.528 128.284c-2.949-4.954-60.223 11.041-61.867 19.202l-38.787 192.499 27.299.261c7.476.071 13.595-5.931 13.666-13.407l.258-34.699 3.156 31.46c.806 8.035 7.49 13.943 14.929 13.197l22.897-2.297c2.476 3.51 6.574 5.79 11.194 5.746l33.247-.318c7.476-.071 13.479-6.19 13.407-13.666l12.926 7.714c.673 7.562 7.255 13.138 14.701 12.454l33.114-3.041c7.446-.684 12.936-7.368 12.263-14.93l-.16-1.76 29.29-.28c7.476-.071 13.479-6.19 13.407-13.666l-.058-8.012c2.114.971 4.5 1.421 6.982 1.172l14.328-1.437z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m428.863 209.06-107.355-83.847c-22.136-17.288-54.737-6.022-61.475 21.245l-41.615 168.409c-1.812 7.261 2.6 14.601 9.85 16.413l32.263 8.049c7.25 1.812 14.601-2.6 16.413-9.85l33.682-136.191 63.851 49.892c6.574 5.111 15.456 6.09 22.976 2.51l28.909-13.711c9.109-4.322 10.46-16.728 2.501-22.919z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.628 193.288-33.682 136.191c-1.812 7.25-9.163 11.662-16.413 9.85l-32.263-8.049c-7.25-1.812-11.663-9.152-9.85-16.413l40.098-162.285z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m117.767 333.41-32.594 6.567c-7.329 1.477-14.468-3.268-15.945-10.597l-46.127-228.93c-1.991-9.883 7.132-18.397 16.854-15.728l30.851 8.469c8.028 2.204 14.13 8.742 15.774 16.903l41.784 207.373c1.476 7.328-3.268 14.467-10.597 15.943z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.767 333.41-32.594 6.567c-7.329 1.477-14.468-3.268-15.945-10.597l-46.127-228.93c-1.991-9.883 7.132-18.397 16.854-15.728l30.851 8.469c8.028 2.204 14.13 8.742 15.774 16.903l41.784 207.373c1.476 7.328-3.268 14.467-10.597 15.943z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.474 370.803 32.594 6.567c7.329 1.477 14.468-3.268 15.945-10.597l46.128-228.931c1.991-9.883-7.132-18.397-16.854-15.728l-30.851 8.469c-8.028 2.204-14.13 8.742-15.774 16.903l-41.784 207.373c-1.478 7.329 3.267 14.468 10.596 15.944z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.505 196.753 26.724 132.628c1.477 7.329 8.615 12.074 15.945 10.597l12.178-2.454c2.152 1.492 4.758 2.378 7.574 2.405l5.949.057-2.997 14.873c-1.477 7.329 3.268 14.468 10.597 15.944l32.594 6.567c7.329 1.477 14.468-3.267 15.945-10.597l6.099-30.271 19.968-2.003c2.476 3.51 6.574 5.79 11.194 5.746l33.247-.318c3.699-.035 7.034-1.554 9.454-3.982l13.558 3.382c1.716.429 3.435.499 5.088.275 2.557 4.493 7.511 7.325 12.935 6.827l33.114-3.041c7.446-.684 12.936-7.368 12.263-14.93l-.16-1.76 29.29-.28c7.476-.071 13.479-6.19 13.407-13.666l-.058-8.012c2.114.971 4.5 1.421 6.982 1.172l3.464-.347-2.376 13.205c-1.341 7.355 3.535 14.405 10.89 15.746l32.71 5.963c7.355 1.341 14.405-3.535 15.746-10.89l23.928-132.838h-415.252z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m443.578 260.005c-22.317 0-44.154 5.924-63.72 16.658-30.904 16.954-76.382 27.668-127.093 27.668s-96.188-10.714-127.093-27.668c-19.566-10.734-41.403-16.658-63.72-16.658-7.052 0-12.244 6.599-10.587 13.453l49.338 203.973c4.902 20.268 23.757 34.025 44.549 32.447 68.494-5.198 146.53-5.198 215.024 0 20.792 1.578 39.647-12.179 44.549-32.447l49.338-203.973c1.659-6.855-3.534-13.453-10.585-13.453z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.322 362.426c-1.681-2.665-4.548-4.562-7.995-4.807-65.048-4.616-138.075-4.616-203.124 0-6.381.453-10.814 6.544-9.308 12.761 2.988 12.335 7.698 31.783 11.087 45.772 1.121 4.626 3.73 8.554 7.219 11.373l78.518 78.518c41.273-.375 82.933.902 121.559 3.833 20.792 1.578 39.647-12.179 44.549-32.447l14.121-58.378z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.895 370.38c2.988 12.335 7.698 31.783 11.087 45.772 2.377 9.811 11.394 16.547 21.474 16.014 51.016-2.7 105.602-2.7 156.618 0 10.08.533 19.098-6.203 21.474-16.014 3.389-13.99 8.099-33.437 11.087-45.772 1.506-6.217-2.927-12.308-9.308-12.761-65.048-4.616-138.076-4.616-203.124 0-6.381.453-10.813 6.544-9.308 12.761z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.517 439.451 9.186 37.979c4.902 20.268 23.757 34.025 44.549 32.447 68.494-5.198 146.53-5.198 215.024 0 20.792 1.578 39.647-12.179 44.549-32.447l9.186-37.979z",
    fill: "url(#SVGID_22_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrenchFries);
export default __webpack_public_path__ + "static/media/icon-french-fries.5c762c9ed9133e3cd8d295084eaa3e69.svg";
export { ForwardRef as ReactComponent };